import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Item } from '../../../../components/Grid';
import HistoryRowControls from '../../../../components/HistoryRowControls';
import HistoryRowListing from '../../../../components/HistoryRowListing';
import HistorySection from '../../../../components/HistorySection';

import { formatPartialDate } from 'Utility/date';
import DocumentCreationButton from '../../../../components/DocumentCreationButton';

const NocturnalPolygraphy = ({ documents, startEdit }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id="clinicalstudy.nocturnalPolygraphy" />}
      newButton={
        <DocumentCreationButton
          name="nocturnalPolygraphy"
          text={'clinicalstudy.newNocturnalPolygraphy'}
          onClick={startEdit({}, 'nocturnalPolygraphy')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={2}>
              <FormattedMessage id="general.date" />
            </Item>
            <Item xs={6}>&nbsp;</Item>
          </>
        }
        contentFormat={(d: INocturnalPolygraphy): React.JSX.Element => (
          <>
            <Item xs={2} style={{ fontWeight: 600 }}>
              {formatPartialDate(d.date ?? undefined)}
            </Item>
            <Item xs={7}>&nbsp;</Item>
            <Item xs={3}>
              <HistoryRowControls document={d} startEdit={startEdit} />
            </Item>
          </>
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: INocturnalPolygraphy[];
  startEdit: (document: TAnyObject, name?: string) => (e: React.MouseEvent<Element, MouseEvent>) => void;
}

export default NocturnalPolygraphy;
